import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, value, ...props }, ref) => {
  const internalRef = React.useRef(null)

  React.useEffect(() => {
    const el = (ref?.current || internalRef.current)
    if (el) { el.style.height = 'auto'; el.style.height = el.scrollHeight + 'px' }
  }, [value, ref])

  return (
    (<textarea
      className={cn(
        "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base placeholder:text-muted-foreground focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 disabled:cursor-default md:text-sm resize-none overflow-hidden",
        className
      )}
      style={{ boxShadow: 'none' }}
      ref={ref || internalRef}
      value={value}
      onInput={(e) => { e.target.style.height = 'auto'; e.target.style.height = e.target.scrollHeight + 'px'; }}
      {...props} />)
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
